import React from 'react';
import { useSearchParams } from 'react-router-dom';

function CrashProbe({ target }) {
  const [searchParams] = useSearchParams();

  if (import.meta.env.DEV && searchParams.get('crash') === target) {
    throw new Error(`Dev crash: ${target}`);
  }

  return null;
}

export default CrashProbe;
